module.exports = __webpack_public_path__ + "static/media/placeholder.0f4ac39b.png";